import React from "react";

import { switchCompanyURL } from "Dashboard/EmployerUrls";
import isIntuit from "Intuit/isIntuit";
import { Helmet } from "react-helmet";
import isSquare from "Square/isSquare";
import companyToken from "Utils/companyToken";
import Heartbeat from "ZeroRuby/snippets/heartbeat";

import { NavItem } from "Cobalt/NavItem";
import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import Icon from "Common/Icon";
import ThemeInstaller from "Common/ThemeInstaller";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

import makeBem from "Utils/makeBem";

const bem = makeBem("LargeGroupMainContent");

type Props = {
  title?: string;
  children?: React.ReactNode;
  headerContent?: React.ReactNode;
};

const branding = isSquare() ? "square" : isIntuit() ? "intuit" : "default";

export default function Chrome({ children, title, headerContent }: Props) {
  const renderNavBar = () => {
    const rightContent = [];
    if (companyToken()) {
      rightContent.push(
        <NavItem key="switchLink" eventKey="switchLink" href={isIntuit() ? `/intuit/router${switchCompanyURL}` : switchCompanyURL}>
          Switch Company
        </NavItem>,
      );
    }
    if (isIntuit()) {
      rightContent.push(
        <NavItem key="logOut" eventKey="logOut" href="/logout">
          <Icon icon="sign-out-alt" flavor="solid" mx={3} />
          Log out
        </NavItem>,
      );
    }

    return <ResponsiveTopBar branding={branding} collapseOnSelect={false} rightContent={rightContent} />;
  };

  return (
    <div>
      <Helmet titleTemplate="SimplyInsured - %s" title={title} defaultTitle="SimplyInsured" />

      {renderNavBar()}
      {headerContent && (
        <Grid mt={5} p={0}>
          {headerContent}
        </Grid>
      )}

      <Grid>{children}</Grid>
      <Footer />
      <Heartbeat />
      <ThemeInstaller />
    </div>
  );
}
